export default "__VITE_ASSET__DQYCuBzc__"